module.exports = __webpack_public_path__ + "static/signature-solid-white-1351d1bc3500b599e1e4c4344a675563.svg";